function nextStaffSmsSelection({
  selectedIds,
  personId,
  canReceive,
  additive,
}) {
  if (!canReceive) return Array.isArray(selectedIds) ? selectedIds.slice() : [];
  const id = Number(personId);
  if (!Number.isFinite(id)) {
    return Array.isArray(selectedIds) ? selectedIds.slice() : [];
  }
  if (!additive) return [id];
  const set = new Set((selectedIds || []).map(Number));
  if (set.has(id)) set.delete(id);
  else set.add(id);
  return [...set];
}

function shouldShowStaffSmsThread(selectedIds) {
  return Array.isArray(selectedIds) && selectedIds.length === 1;
}

function staffSmsThreadPlaceholder(selectedIds) {
  if (shouldShowStaffSmsThread(selectedIds)) return '';
  return 'Select one staff member to see message history';
}

function mergeSmsHistory(existing, incoming) {
  const byId = new Map();
  for (const row of existing || []) {
    if (row && row.id != null) byId.set(Number(row.id), row);
  }
  for (const row of incoming || []) {
    if (row && row.id != null) byId.set(Number(row.id), row);
  }
  return [...byId.values()].sort((a, b) => {
    const aTime = new Date(a.createdAt).getTime() || 0;
    const bTime = new Date(b.createdAt).getTime() || 0;
    if (aTime !== bTime) return aTime - bTime;
    return Number(a.id) - Number(b.id);
  });
}

function formatStaffSmsStamp(value, timeZone = 'America/Detroit') {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value || '';
  const dayPeriod = get('dayPeriod').toLowerCase().replace(/\./g, '');
  return `${get('month')}/${get('day')}/${get('year')} ${get('hour')}:${get('minute')}${dayPeriod}`;
}

function shouldStickToBottom({
  scrollTop,
  clientHeight,
  scrollHeight,
  threshold = 24,
}) {
  return Number(scrollTop) + Number(clientHeight) >= Number(scrollHeight) - threshold;
}

module.exports = {
  nextStaffSmsSelection,
  shouldShowStaffSmsThread,
  staffSmsThreadPlaceholder,
  mergeSmsHistory,
  formatStaffSmsStamp,
  shouldStickToBottom,
};
